// Centralized data-testid constants
export const TID = {
  // Landing
  landingHero: 'landing-hero',
  ctaGetStarted: 'cta-get-started',
  ctaLogin: 'cta-login',
  // Auth
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-btn',
  registerEmail: 'register-email-input',
  registerPassword: 'register-password-input',
  registerName: 'register-name-input',
  registerRole: 'register-role-select',
  registerSubmit: 'register-submit-btn',
  logoutBtn: 'logout-btn',
  // Nav
  navDashboard: 'nav-dashboard',
  navPlaybook: 'nav-playbook',
  navEditor: 'nav-editor',
  navRoster: 'nav-roster',
  navAI: 'nav-ai-coach',
  navLive: 'nav-live-game',
  navAcademy: 'nav-academy',
  navInvitations: 'nav-invitations',
  navAdmin: 'nav-admin',
  navPricing: 'nav-pricing',
  langSwitcher: 'language-switcher',
  // Playbook
  playCard: 'play-card',
  playFilterCategory: 'play-filter-category',
  playSearch: 'play-search-input',
  playAnimatePlay: 'play-animate-btn',
  playStepNext: 'play-step-next',
  playStepPrev: 'play-step-prev',
  // Editor
  editorSave: 'editor-save-btn',
  editorAddStep: 'editor-add-step-btn',
  editorPlayName: 'editor-play-name',
  editorCategory: 'editor-category',
  // Roster
  rosterAdd: 'roster-add-btn',
  rosterPlayerCard: 'roster-player-card',
  rosterUploadPhoto: 'roster-upload-photo',
  rosterPlayerName: 'roster-player-name-input',
  rosterPlayerNumber: 'roster-player-number-input',
  rosterPlayerSave: 'roster-player-save-btn',
  // Invitations
  inviteGenerate: 'invite-generate-btn',
  inviteCopy: 'invite-copy-btn',
  // AI
  aiInput: 'ai-input',
  aiSend: 'ai-send-btn',
  aiGenerate: 'ai-generate-play-btn',
  aiPredict: 'ai-predict-btn',
  aiRecommend: 'ai-recommend-btn',
  // Live
  liveDefenseSelect: 'live-defense-select',
  liveMomentSelect: 'live-moment-select',
  liveRecommendBtn: 'live-recommend-btn',
  // Admin
  adminDashboard: 'admin-dashboard',
};
